import { Injectable } from '@angular/core';
import { Inspection } from './inspection.dto';
import { Asset } from '../asset/asset.dto';
import { InspectionService } from './inspection.service';

@Injectable()
export class InspectionReviewService {
  constructor(private readonly inspectionService: InspectionService) {}

  async removeAssets(inspection: Inspection, assets: Asset[]): Promise<void> {
    inspection.reviews = inspection.reviews.filter((r) => !assets.find((a) => a._id === r._id));
    await this.inspectionService.updateReviewsWithStats(inspection);
  }

  async addAssets(inspection: Inspection, assets: Asset[]): Promise<void> {
    assets.forEach((a) => {
      if (!inspection.reviews.find((r) => r._id === a._id)) {
        inspection.reviews.push({ _id: a._id, toReview: true });
      }
    });
    await this.inspectionService.updateReviewsWithStats(inspection);
  }

  async reviewAssets(inspection: Inspection, assets: Asset[]): Promise<void> {
    assets.forEach((a) => {
      const review = inspection.reviews.find((r) => r._id === a._id);
      if (review) {
        review.toReview = false;
      }
    });
    await this.inspectionService.updateReviewsWithStats(inspection);
  }
}
